import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import MyProfile from './pages/MyProfile';
import Dispatched from './pages/Dispatched'
import OrdersList from './pages/OrdersList';
import AddOrder from './pages/AddOrder';
import OrderDetails from './pages/OrderDetails';
import EditOrder from './pages/EditOrder';
import VerifiedOrders from './pages/VerifiedOrders';
import VerifiedOrderDetails from './pages/VerifiedOrderDetails';
import EmployeeManagement from './pages/EmployeeManagement';
import FloorManagement from './pages/FloorManagement';
import AddFloor from './pages/AddFloor';
import Leads from './pages/Leads';
import EmployeeDetail from './pages/EmployeeDetail';
import Login from './pages/Login';
import B2BPartners from './pages/B2BPartners';
import AddB2BPartner from './pages/AddPartner';
import B2BPartnerDetail from './pages/B2BPartnerDetail';
import Centers from './pages/Centers';
import PurchaseOrders from './pages/PurchaseOrders';
import AddPurchaseOrder from './pages/AddPurchaseOrder';
import PurchaseOrderDetail from './pages/PurchaseOrderDetail';
import { mockOrders } from './utils/constants';
import DispatchOrder from './pages/Dispatchorder';
import OFDOrders from './pages/OFDOrders';
import DeliveredOrders from './pages/DeliveredOrders';
import NDROrders from './pages/NDROrders';
import DispatchOrderverified from './pages/DispatchOrderverified';
import InTransit from './pages/InTransit';
import NDRRequest from './pages/NDRRequest';
import RTO from './pages/Rto';
import DashboardRealtime from './pages/DashboardRealtime';
import DashboardLead from './pages/DashboardLead';
import DashboardOrder from './pages/DashboardOrder';
import AddCourierCredential from './pages/AddCourierCredential';
import DraftOrders from './pages/DraftOrders';
import StockDashboard from './pages/StockDashboard';
import StockIn from './pages/StockIn';
import StockTransfer from './pages/StockTransfer';
import StockReturns from './pages/StockReturns';
import StockLedger from './pages/StockLedger';
import StockSampling from './pages/StockSampling';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { PartnerProvider } from './context/PartnerContext';
import { PermissionProvider } from './context/PermissionContext';
import { RoutePermissionGuard, ProtectedPage } from './context/Permissionguards';
import CreatePermission from './pages/CreatePermission';
import { useSession } from './hooks/UseSession';
///Settings Pages Starts Here /////
import SettingsLeadApi from './pages/SettingsLeadApi';
import SettingsOrderCampaign from './pages/SettingsOrderCampaign';
import SettingsLeadDisposition from './pages/SettingsLeadDisposition';
import SettingsCourierApi from './pages/SettingsCourierApi';
import OrderReassign from './pages/OrderReassign';
// Employees List Table Pages Starts Here /////
import EmployeesListTable from './pages/EmployeesListTable';
import AddEmployee from './pages/AddEmployee';
import UserPermission from './pages/UserPermission';

// Billing Pages Starts Here /////
import Billing from './pages/Billing';
import BillingSelfProfile from './pages/BillingSelfProfile';
import BillingList from './pages/BillingList';
import AddBillProfile from './pages/AddBillProfile';
import AddBillProfileStep2 from './pages/AddBillProfileStep2';
import InvoiceDetails from './pages/InvoiceDetails';

// Products Pages Starts Here /////
import Products from './pages/Products';
import ProductCategory from './pages/ProductCategory';
import ProductSubcategory from './pages/ProductSubcategory';
import ProductList from './pages/ProductList';
import AddProduct from './pages/AddProduct';
import ProductDetails from './pages/ProductDetails';
import AmountDecreaseOrderDetails from './pages/AmountDecreaseOrderDetails';
import Purchase from './pages/Purchase';
import PurchaseInvoice from './pages/PurchaseInvoice';

// Ledger Pages
import LedgerPartners from './pages/LedgerPartners';
import LedgerStock from './pages/LedgerStock';
import Analytics from './pages/Analytics';
import AhtBucket from './pages/AhtBucket';
import Attendance from './pages/Attendance';
import BusinessDashboard from './pages/BusinessDashboard';
import MISOrdersTarget from './pages/MISOrdersTarget';
import MISRevenueTarget from './pages/MISRevenueTarget';
import MISConversionTarget from './pages/MISConversionTarget';
import DispatchFailed from './pages/DispatchFailed';
import VerifiedFailedOrderDetail from './pages/VerifiedFailedOrderDetail';
import AgentTargets from './pages/AgentTargets';
import ManualAssignPanel from './pages/Manualassignpanel';
// ✅ CHANGE 1 — FloatingDialer import
import FloatingDialer from './components/FloatingDialer';
import AIQueryFloatingButton from './pages/AIQueryFloatingButton';
import WhatsAppPage from './pages/Whatsapppage ';
import FloatingWhatsAppDrawer from './components/FloatingWhatsAppDrawer';
// Protected Route Component
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('authToken');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

// ✅ CHANGE 2 — FloatingDialer state + render inside AuthenticatedLayout
function AuthenticatedLayout({ children }) {
  const { currentTheme } = useTheme();

  // Open states for global sliding drawers
  const [isWhatsAppOpen, setIsWhatsAppOpen] = useState(false);
  const [isAIOpen, setIsAIOpen] = useState(false);

  const userRole = (() => {
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      const designation = (u.designation || u.role || '').toLowerCase();
      if (designation.includes('verif')) return 'verification';
      return 'agent';
    } catch { return 'agent'; }
  })();

  // ✅ NAYA — sirf Admin check ke liye alag variable
  const isAdmin = (() => {
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      const designation = (u.designation || u.role || '').toLowerCase();
      return designation.includes('admin');
    } catch { return false; }
  })();

  // Spacing dynamically calculated to prevent overlap with content
  const rightSpacing = Math.max(isWhatsAppOpen ? 418 : 0, (isAdmin && isAIOpen) ? 462 : 0);

  return (
    <div
      className={`min-h-screen transition-colors duration-300 ${(['Purple', 'Black'].includes(currentTheme.name)) ? 'dark' : ''}`}
      style={{
        backgroundColor: (['Purple', 'Black'].includes(currentTheme.name))
          ? '#0f172a'
          : (currentTheme.bgColor ? currentTheme.bgColor : (currentTheme.name === 'Teal (Default)' ? '#FFFFFF' : currentTheme.color + '12')),
        color: (['Purple', 'Black'].includes(currentTheme.name)) ? '#FFFFFF' : '#000000'
      }}
    >
      <Header />
      <div className="flex w-full min-w-0 max-w-full">
        <Sidebar />
        <main
          className="flex-1 min-w-0 p-6 desktop:p-8 overflow-visible transition-all duration-300 ease-in-out"
          style={{ marginRight: `${rightSpacing}px` }}
        >
          {/* 🔐 Har protected route yahan se guzarta hai — routePermissions.js
              ke map se permission check hoti hai (fail-closed). */}
          <RoutePermissionGuard>{children}</RoutePermissionGuard>
        </main>
      </div>
      <FloatingDialer role={userRole} />
      {isAdmin && <AIQueryFloatingButton open={isAIOpen} setOpen={setIsAIOpen} />}  {/* ✅ SIRF ADMIN KO DIKHEGA */}
      <FloatingWhatsAppDrawer isOpen={isWhatsAppOpen} setIsOpen={setIsWhatsAppOpen} />
    </div>
  );
}

// ✅ Dynamic Target Component based on role
function TargetView() {
  const user        = JSON.parse(localStorage.getItem('user') || '{}');
  const permissions = JSON.parse(localStorage.getItem('userPermissions') || '[]');
  const role        = (user.role || user.designation || '').toUpperCase();
  const designationId = user.designationId;

  // ✅ TL designation ID = 1 (DB confirm)
  const TL_DESIGNATION_IDS = [1];

  // ✅ Permission check
  const hasTargetAssign = permissions.includes('TARGET_ASSIGN');

  // ✅ Assign permissions: Admin / Manager / Floor Manager / Team Leader
  const canAssign =
    role.includes('ADMIN') ||
    role.includes('MANAGER') ||
    role.includes('TEAM_LEAD') ||
    role.includes('TL') ||
    role.includes('FLOOR_MANAGER') ||
    TL_DESIGNATION_IDS.includes(designationId) ||
    hasTargetAssign;

  // Management ko Assign Target page dikhega
  if (canAssign) return <MISOrdersTarget />;

  // Baki sabhi Agents / Employees ko strictly Agent Targets screen dikhega
  return <AgentTargets />;
}

// ✅ Guard: Prevents Admin from opening employee /dashboard
function DashboardRouteGuard() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = (user.role || user.designation || '').toLowerCase();
  const isAdmin = role.includes('admin');

  if (isAdmin) {
    return <Navigate to="/dashboard/realtime" replace />;
  }
  return <Dashboard />;
}

// ✅ Default redirect helper based on role
function DefaultRedirect() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = (user.role || user.designation || '').toLowerCase();
  const isAdmin = role.includes('admin');

  return <Navigate to={isAdmin ? "/dashboard/realtime" : "/dashboard"} replace />;
}

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [orders] = useState(mockOrders);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [editingOrder, setEditingOrder] = useState(null);

  const isAuthenticated = localStorage.getItem('authToken');
  const isLoginPage = location.pathname === '/login';

  const handleViewChange = (view) => {
    setSelectedOrder(null);
    setEditingOrder(null);
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    const isAdmin = (u.designation || u.role || '').toLowerCase().includes('admin');
    const routeMap = {
      'dashboard': isAdmin ? '/dashboard/realtime' : '/dashboard',
      'orders': '/orders',
      'all-orders': '/orders',
      'add-order': '/orders/add',
      'draft-order': '/orders/draft',
      'verified': '/verified',
      'verified-orders': '/verified',
      'pending-verification': '/verified',
      'ndr': '/ndr',
      'ndr-pending': '/ndr/pending',
      'ndr-resolved': '/ndr/resolved',
      'leads': '/leads',
      'employees': '/employees',
      'floor': '/floor',
      'b2b-partners': '/b2b-partners',
      'purchase-orders': '/purchase/orders',
      'business-dashboard': '/mis-reports/business-dashboard'
    };
    const route = routeMap[view] || (isAdmin ? '/dashboard/realtime' : '/dashboard');
    navigate(route);
  };

  const handleViewOrder   = (order) => { setSelectedOrder(order); setEditingOrder(null); navigate(`/orders/${order.id}`); };
  const handleEditOrder   = (order) => { setEditingOrder(order); setSelectedOrder(null); navigate(`/orders/${order.id}/edit`); };
  const handleCloseEditOrder     = () => { setEditingOrder(null); navigate('/orders'); };
  const handleCloseOrderDetails  = () => { setSelectedOrder(null); navigate('/orders'); };

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />

      {/* Full Screen — No Sidebar/Header */}
      {/* Ye AuthenticatedLayout ke bahar hain, isliye RoutePermissionGuard inhe
          cover nahi karta — yahan seedha ProtectedPage lagaya hai. */}
      <Route path="/billing/invoice/:id"  element={<ProtectedRoute><ProtectedPage permission="BILLING_VIEW"><InvoiceDetails /></ProtectedPage></ProtectedRoute>} />
      <Route path="/purchase/invoice/:id" element={<ProtectedRoute><ProtectedPage permission="B2B_VIEW"><PurchaseInvoice /></ProtectedPage></ProtectedRoute>} />

      {/* Protected Routes with Layout */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AuthenticatedLayout>
              <Routes>
                {/* Dashboard */}
                <Route path="/dashboard"            element={<DashboardRouteGuard />} />
                <Route path="/my-profile"           element={<MyProfile />} />
                <Route path="/dispatched"           element={<Dispatched />} />
                <Route path="/dashboard/realtime"   element={<DashboardRealtime />} />
                <Route path="/dashboard/lead"       element={<DashboardLead />} />
                <Route path="/dashboard/order"      element={<DashboardOrder />} />

                {/* Orders */}
                <Route path="/orders" element={<OrdersList orders={orders} onAddOrder={() => navigate('/orders/add')} onViewOrder={handleViewOrder} onEditOrder={handleEditOrder} />} />
                <Route path="/orders/add"     element={<AddOrder onClose={() => navigate('/orders')} />} />
                <Route path="/orders/draft"   element={<DraftOrders />} />
                <Route path="/orders/reassign" element={<OrderReassign />} />
                <Route path="/orders/:id"     element={selectedOrder ? <OrderDetails order={selectedOrder} onClose={handleCloseOrderDetails} onEdit={handleEditOrder} /> : <Navigate to="/orders" replace />} />
                <Route path="/orders/:id/edit" element={<EditOrder />} />
                <Route path="/orders/amount-decrease/:id" element={<AmountDecreaseOrderDetails />} />

                {/* Verified */}
                <Route path="/verified"           element={<VerifiedOrders />} />
                <Route path="/verified/orders"    element={<VerifiedOrders />} />
                <Route path="/verified/pending"   element={<VerifiedOrders />} />
                <Route path="/verified/order/:id" element={<VerifiedOrderDetails />} />
                <Route path="/ManualAssignPanel"           element={<ManualAssignPanel />}/>
                {/* NDR */}
                <Route path="/ndr"          element={<div className="text-2xl font-bold">NDR Dashboard</div>} />
                <Route path="/ndr/pending"  element={<div className="text-2xl font-bold">NDR Pending Orders</div>} />
                <Route path="/ndr/resolved" element={<div className="text-2xl font-bold">NDR Resolved Orders</div>} />

                {/* Leads */}
                <Route path="/leads" element={<Leads />} />
                <Route path="/whatsapp" element={<WhatsAppPage />} />
                {/* Analytics */}
                <Route path="/analytics"            element={<Analytics />} />
                <Route path="/analytics/aht-bucket" element={<AhtBucket />} />

                {/* MIS Reports */}
                <Route path="/mis-reports/business-dashboard"  element={<BusinessDashboard />} />
                <Route path="/mis-reports/orders-target"       element={<MISOrdersTarget />} />
                <Route path="/target"                          element={<TargetView />} />
                <Route path="/agent-targets"                   element={<AgentTargets />} />
                <Route path="/mis-reports/revenue-target"      element={<MISRevenueTarget />} />
                <Route path="/mis-reports/conversion-target"   element={<MISConversionTarget />} />

                {/* Employees */}
                <Route path="/employees"                    element={<EmployeeManagement />} />
                <Route path="/employees/list"               element={<EmployeesListTable />} />
                <Route path="/employees/user-permission"    element={<UserPermission />} />
                <Route path="/employees/createPermission"   element={<CreatePermission />} />
                <Route path="/employees/add"                element={<AddEmployee />} />
                <Route path="/add/employee"                 element={<AddEmployee />} />
                <Route path="/employees/edit/:id"           element={<AddEmployee />} />
                <Route path="/employees/:id"                element={<EmployeeDetail />} />

                {/* Floor */}
                <Route path="/floor"     element={<FloorManagement />} />
                <Route path="/floor/add" element={<AddFloor />} />

                {/* B2B Partners */}
                <Route path="/b2b-partners"              element={<B2BPartners />} />
                <Route path="/b2b-partners/add"          element={<AddB2BPartner />} />
                <Route path="/b2b-partners/:id/edit"     element={<AddB2BPartner />} />
                <Route path="/b2b-partners/:id"          element={<B2BPartnerDetail />} />
                <Route path="/b2b-partners/:id/document" element={<div className="min-h-screen bg-[#FBFDFF] p-8 text-2xl font-bold text-gray-800">Document Page (Coming Soon)</div>} />
                <Route path="/b2b-partners/:id/invoice"  element={<div className="min-h-screen bg-[#FBFDFF] p-8 text-2xl font-bold text-gray-800">Invoice Page (Coming Soon)</div>} />
                <Route path="/b2b-partners/:id/action-edit" element={<div className="min-h-screen bg-[#FBFDFF] p-8 text-2xl font-bold text-gray-800">Edit Partner (Coming Soon)</div>} />
                <Route path="/centers"                   element={<Centers />} />

                {/* Ledger */}
                <Route path="/ledger/partners" element={<LedgerPartners />} />
                <Route path="/ledger/stock"    element={<LedgerStock />} />

                {/* Purchase */}
                <Route path="/purchase/orders"           element={<PurchaseOrders />} />
                <Route path="/purchase/add"              element={<AddPurchaseOrder />} />
                <Route path="/purchase/orders/create"    element={<div className="min-h-screen bg-[#FBFDFF] p-8 text-2xl font-bold text-gray-800">Create Purchase Order (Coming Soon)</div>} />
                <Route path="/purchase/orders/:id"       element={<PurchaseOrderDetail />} />
                <Route path="/purchase/orders/:id/edit"  element={<AddPurchaseOrder />} />
                <Route path="/purchase"                  element={<Purchase />} />

                {/* Dispatch / Workflow */}
                <Route path="/DispatchOrder"         element={<DispatchOrder />} />
                <Route path="/DispatchOrderverified" element={<DispatchOrderverified />} />
                <Route path="/OFDOrders"             element={<OFDOrders />} />
                <Route path="/DeliveredOrders"       element={<DeliveredOrders />} />
                <Route path="/NDROrders"             element={<NDROrders />} />
                <Route path="/dispatch-failed"       element={<DispatchFailed />} />
                <Route path="/order-details/:id"     element={<VerifiedFailedOrderDetail />} />
                <Route path="/NDRRequest"            element={<NDRRequest />} />
                <Route path="/RTO"                   element={<RTO />} />
                <Route path="/InTransit"             element={<InTransit />} />

                {/* Settings */}
                <Route path="/settings/lead-api"          element={<SettingsLeadApi />} />
                <Route path="/settings/order-campaign"    element={<SettingsOrderCampaign />} />
                <Route path="/settings/lead-disposition"  element={<SettingsLeadDisposition />} />
                <Route path="/settings/courier-api"       element={<SettingsCourierApi />} />
                <Route path="/settings/courier-api/add"   element={<AddCourierCredential />} />

                {/* Billing */}
                <Route path="/billing"                element={<Billing />} />
                <Route path="/billing/self-profile"   element={<BillingSelfProfile />} />
                <Route path="/billing/list"           element={<BillingList />} />
                <Route path="/billing/add-profile"    element={<AddBillProfile />} />
                <Route path="/billing/add-profile/step2" element={<AddBillProfileStep2 />} />

                {/* Products */}
                <Route path="/products"              element={<Products />} />
                <Route path="/products/category"     element={<ProductCategory />} />
                <Route path="/products/subcategory"  element={<ProductSubcategory />} />
                <Route path="/products/list"         element={<ProductList />} />
                <Route path="/products/add"          element={<AddProduct />} />
                <Route path="/products/:id"          element={<ProductDetails />} />

                {/* Attendance */}
                <Route path="/attendance" element={<Attendance />} />

                {/* Stock Management (Blank Pages with H1 heading) */}
                <Route path="/stock-management/dashboard" element={<StockDashboard />} />
                <Route path="/stock-management/stock-in" element={<StockIn />} />
                <Route path="/stock-management/transfer" element={<StockTransfer />} />
                <Route path="/stock-management/returns" element={<StockReturns />} />
                <Route path="/stock-management/ledger" element={<StockLedger />} />
                <Route path="/stock-management/sampling" element={<StockSampling />} />

                {/* Default */}
                <Route path="/"  element={<DefaultRedirect />} />
                <Route path="*"  element={<DefaultRedirect />} />
              </Routes>
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
   useSession();
  return (
    <BrowserRouter>
      <ThemeProvider>
        <PermissionProvider>
          <PartnerProvider>
            <AppContent />
          </PartnerProvider>
        </PermissionProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;